"use client";

import Image from "next/image";
import { useRouter } from "next/navigation";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
import Link from "@/components/ui/Link";

type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};

type HorizontalSmallNewsItem = {
  category?: FieldConfig;
  title?: FieldConfig;
  timeAgo?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  priority?: boolean;
  imageMetadata?: ImageMetadata;
};

type Props = HorizontalSmallNewsItem & {
  data?: HorizontalSmallNewsItem[];
  imageMetadata?: ImageMetadata;
};

export default function HorizontalSmallImageHeadingNews({
  data,
  category = { hidden: false, value: "ஐபிஎல் 2023", customClass: "" },
  title = { hidden: false, value: "", customClass: "" },
  timeAgo = { hidden: false, value: "May 17, 2023", customClass: "" },
  imageSrc = { hidden: false, value: FALLBACK_IMAGE, customClass: "" },
  slug,
  priority = false,
  imageMetadata,
}: Props) {
  const router = useRouter();
  const items = data ?? [
    { category, title, timeAgo, imageSrc, slug },
  ];

  const renderCard = ({
    category: itemCategory,
    title: itemTitle,
    timeAgo: itemtimeAgo,
    imageSrc: itemImageSrc,
    slug: itemSlug,
    imageMetadata: itemImageMetadata,
  }: HorizontalSmallNewsItem, index: number) => {
    const catVal = itemCategory?.value ?? category?.value ?? "";
    const titleVal = itemTitle?.value ?? title?.value ?? "";
    const imgVal = getImageUrl(itemImageSrc?.value ?? imageSrc?.value) || FALLBACK_IMAGE;

    return (
      <article
        key={itemSlug ?? `${catVal ?? titleVal}-${itemtimeAgo?.value ?? timeAgo?.value}-${index}`}
        className={`flex gap-4 p-4 ${itemSlug ? "cursor-pointer" : ""}`}
      >
        {/* Left: Image */}
        {!(itemImageSrc?.hidden ?? imageSrc?.hidden) && (
          <div className={`w-16 h-[80px] shrink-0 ${itemImageSrc?.customClass ?? imageSrc?.customClass ?? ""}`}>
            <Image
              src={imgVal}
              alt={titleVal || catVal || ""}
              width={64}
              height={80}
              className="w-full h-full object-cover"
              style={getFocusPointStyle(itemImageMetadata ?? imageMetadata)}
              loading={priority ? "eager" : "lazy"}
              fetchPriority={priority ? "high" : "auto"}
              priority={priority}
              placeholder="blur"
              blurDataURL={BLUR_PLACEHOLDER}
            />
          </div>
        )}

        {/* Right: Content */}
        <div className="flex flex-col flex-1 gap-2 justify-center">
          {/* Category / Title */}
          {!(itemCategory?.hidden ?? category?.hidden) && (
            <div className={`text-16-tamil-700 text-1B1B1B line-clamp-2 ${itemCategory?.customClass ?? category?.customClass ?? ""}`}>
              {catVal || titleVal}
            </div>
          )}
        </div>
      </article>
    );
  };

  return (
    <Link href={`${slug}`} className="block  transition-colors cursor-pointer">
      {items.map((item, index) => renderCard(item, index))}
    </Link>
  );
}
